import 'src/styles/login.css';

import { Button, Flex } from 'antd';
import { MouseEvent, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppDispatch } from 'src/app/hooks';
import { fetchUseMe } from 'src/appRedux/reducers/userReducer';
import bg_login from 'src/assets/images/bg-login.jpg';
import { setCookieValue } from 'src/util/Commom';
import configUrl from 'src/util/config';

import { LoginOutlined } from '@ant-design/icons/lib/icons';

const SignIn = () => {
  const paramsToken = new URLSearchParams(window.location.search).get("token");
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const location = useLocation();
  useEffect(() => {
    if (paramsToken) {
      setCookieValue("accessTokenTVDTBDT", paramsToken);
      navigate("/home");
      dispatch(fetchUseMe());
    }
    if (
      location &&
      location.state &&
      location.state.from.pathname.includes("Forbidden")
    ) {
      navigate("/Forbidden");
    }
  }, [paramsToken, dispatch]);

  const handleSubmit = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    window.location.href = `${configUrl.API_URL}/secure/token?redirectTo=${window.location.href}`;
  };

  const boxStyle: React.CSSProperties = {
    // width: "100%",
    height: 231,
    borderRadius: 12,
    border: "1px solid #40a9ff"
  };

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        flexWrap: "nowrap"
      }}
    >
      <div className="custom-login">
        <Flex gap="middle" align="start" vertical>
          <Flex style={boxStyle} justify={"center"} align={"center"}>
            <div className="baground-login">
              <img alt="example" src={bg_login} width="100%" />
            </div>
            <div style={{ padding: 25, textAlign: "center" }}>
              <h5 style={{ color: "red", lineHeight: 1.5, fontSize: "18px", margin: 10 }}>
              THƯ VIỆN ĐIỆN TỬ CÔNG TÁC DÂN TỘC<br/>TỈNH QUẢNG NAM
              </h5>
              {!paramsToken ? (
                <Button
                  shape="round"
                  type="primary"
                  icon={<LoginOutlined />}
                  onClick={handleSubmit}
                >
                  Đăng nhập
                </Button>
              ) : (
                <Button>Đang chuyển trang</Button>
              )}
            </div>
          </Flex>
        </Flex>
      </div>
      <p
        style={{
          margin: 10,
          color: "#ababab",
          fontSize: 12,
          lineHeight: 1.5,
          textAlign: "center"
        }}
      >
        Phát triển bởi Trung tâm CNTT - VNPT Quảng Nam
      </p>
    </div>
  );
};

export default SignIn;
